<template>
  <div class="device-i">
    <div class="text-right">
      <button-group :group="group" @change="changePower"></button-group>
    </div>
    <div>
      <img :src="icon" style="width: 60px"/>
    </div>
    <div>
      <div class="title"><span v-text="device.name"></span><span>开/关</span></div>
      <div class="remark"><span v-text="device.state?'已开启':'已关闭'"></span></div>
    </div>
  </div>
</template>

<script>
import api from '../model/device'
import { Message } from 'element-ui'
import ButtonGroup from './ButtonGroup'
import report from '../model/report'
import { mapState } from 'vuex'

export default {
  name: 'DeviceSimple',
  components: { ButtonGroup },
  data () {
    return {
      group: [
        { name: '关', selected: false },
        { name: '开', selected: false }
      ]
    }
  },
  props: ['device'],
  computed: {
    ...mapState(['extDevices', 'otherExtDevices']),
    icon () {
      let icon = null
      switch (this.device.type) {
        case 'all':
          icon = this.device.state ? require('../assets/images/device/small/device_all_e.png') : require('../assets/images/device/small/device_all.png')
          break
        case 'light':
          icon = this.device.state ? require('../assets/images/device/small/device_light_e.png') : require('../assets/images/device/small/device_light.png')
          break
        case 'aircon':
          icon = this.device.state ? require('../assets/images/device/small/device_aircon_e.png') : require('../assets/images/device/small/device_aircon.png')
          break
        case 'curtain':
          icon = this.device.state ? require('../assets/images/device/small/device_curtain_e.png') : require('../assets/images/device/small/device_curtain.png')
          break
        case 'airpure':
          icon = this.device.state ? require('../assets/images/device/small/device_airpure_e.png') : require('../assets/images/device/small/device_airpure.png')
          break
        case 'fan':
          icon = this.device.state ? require('../assets/images/device/small/device_fan_e.png') : require('../assets/images/device/small/device_fan.png')
          break
        case 'switch':
          icon = this.device.state ? require('../assets/images/device/small/device_switch_e.png') : require('../assets/images/device/small/device_switch.png')
          break
        case 'airswitch':
          icon = this.device.state ? require('../assets/images/device/switch/airswitch.png') : require('../assets/images/device/switch/air_switch_off.png')
          break
        case 'lora_aircon':
          icon = this.device.state ? require('../assets/images/device/small/device_aircon_e.png') : require('../assets/images/device/small/device_aircon.png')
          break
          // colorbar 暂用于屏蔽仪
        case 'colorbar':
          icon = this.device.state ? require('../assets/images/device/switch/airswitch.png') : require('../assets/images/device/switch/air_switch_off.png')
          break
      }
      return icon
    }
  },
  methods: {
    async changePower (state) {
      // 根据当前的状态进行设备控制 按类型控制
      try {
        if (this.device.type === 'switch' || this.device.type === 'all') {
          if (this.otherExtDevices.length) {
            for (let i = 0; i < this.otherExtDevices.length; i++) {
              await api.otherExtDeviceControl({ deviceId: this.otherExtDevices[i]['unique'], cmdParam: state ? 1 : 2, channel: 1 })
            }
          }
        }
        if (this.device.type === 'switch') {
          let len = this.extDevices.filter(e => e.devicetype.key === 'switch' && e.name.indexOf('射灯') === -1)
          if (len.length) {
            await api.batchControl([this.device.type], state ? 'open' : 'close')
          }
        } else {
          await api.batchControl([this.device.type], state ? 'open' : 'close')
        }

        // this.$emit('change', this.device, state)
        // 记录操作
        report.traceEvent('click', `${this.device.type} ${state ? 'open' : 'close'}`)
      } catch (e) {
        Message.error(e.message)
      }
    }
  },
  mounted () {
    const index = this.device.state ? 1 : 0
    this.group.forEach((g, i) => {
      if (i === index) {
        g.selected = true
      } else {
        g.selected = false
      }
    })
    this.$emit('change', 'deviceHtml')
  },
  watch: {
    'device' () {
      const index = this.device.state ? 1 : 0
      this.group.forEach((g, i) => {
        if (i === index) {
          g.selected = true
        } else {
          g.selected = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.device-i {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
  border-radius: 6px;
  min-width: 176px;
  padding: 20px;
  box-shadow: 0px 3px 17px 2px rgba(219, 219, 219, 0.3);
  justify-content: space-between;
  img {
    cursor: pointer;
  }
  .title {
    font-size: 17px;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
  }
  .remark {
    font-size: 13px;
    font-weight: 400;
    color: rgba(191, 191, 191, 1);
  }
}
</style>
